import { getDeviceTypeFromUserAgent, isAddFormMobileModeEnabled } from './utils';
import { identifyDeviceType } from '@cian/utils';
import { IAdaptiveSettings } from '../../types/layout';

export interface ICalculateParams {
  userAgent: string;
  deviceWidth?: number;
}

export function getAdaptiveSettings(params: ICalculateParams): IAdaptiveSettings {
  const { userAgent, deviceWidth } = params;

  const deviceType = identifyDeviceType(userAgent);
  const deviceOperatingSystem = getDeviceTypeFromUserAgent(userAgent);
  const isMobile = deviceWidth ? deviceWidth < 800 : isAddFormMobileModeEnabled(deviceType);

  return { deviceType, isMobile, deviceOperatingSystem };
}
